/* SS / Compare (2026-10-12, v3): contents, progress, reading dock, page edges, the versus table's paging
 * and the brand deck of a compare page.
 *
 * The page is a run of theme sections: article chapters (sections/ss-compare-*) between the paid
 * landing's full-width proof sections. Every chapter carries data-ssc-nav="Label" on its root;
 * the head section's "Extra contents" lines (Label | selector) add the full-width sections. This
 * script lists them all in document order in the rail (desktop), the in-page contents (phones)
 * and the dock's sheet, marks the current one, drives the progress bar and ring, and shows the
 * dock after the first screen until the buy zone is in view. The page reads fine without it.
 */
(function () {
  'use strict';
  var head = document.querySelector('[data-ssc-head]');
  if (!head) return;
  var txt = function (el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); };
  var esc = function (s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };

  /* 1. Entries: chapters by attribute, extras by selector, sorted by position. */
  var entries = [].map.call(document.querySelectorAll('[data-ssc-nav]'), function (el) {
    return { el: el, label: el.getAttribute('data-ssc-nav'), id: el.id };
  });
  var extra = head.querySelector('[data-ssc-extra]');
  if (extra) {
    txt(extra).split('\n').concat((extra.innerHTML || '').split(/\n|<br\s*\/?>/)).forEach(function (line) {
      var parts = line.split('|');
      if (parts.length < 2) return;
      var label = parts[0].replace(/<[^>]+>/g, '').trim(), sel = parts.slice(1).join('|').replace(/<[^>]+>/g, '').trim();
      if (!label || !sel) return;
      var el = null;
      try { el = document.querySelector(sel); } catch (e) { el = null; }
      if (!el || entries.some(function (e) { return e.el === el; })) return;
      if (!el.id) el.id = 'ssc-' + label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      el.style.scrollMarginTop = 'calc(var(--ssa-top, 96px) + 8px)';
      entries.push({ el: el, label: label, id: el.id });
    });
  }
  entries = entries.filter(function (e) { return e.id; });
  entries.sort(function (a, b) { return a.el.compareDocumentPosition(b.el) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; });

  /* 2. Lists. */
  var lists = [].slice.call(document.querySelectorAll('[data-ssc-toc]'));
  if (entries.length >= 3) {
    lists.forEach(function (ol) {
      ol.innerHTML = entries.map(function (e) { return '<li><a href="#' + esc(e.id) + '">' + esc(e.label) + '</a></li>'; }).join('');
    });
    var rail = head.querySelector('[data-ssc-rail]'), contents = head.querySelector('[data-ssc-contents]'), count = head.querySelector('[data-ssc-count]');
    if (rail) rail.hidden = false;
    if (contents) { contents.hidden = false; contents.addEventListener('click', function (e) { if (e.target.closest('a')) contents.open = false; }); }
    if (count) count.textContent = entries.length + ' sections';
  }

  /* 3. Reading time from the chapters' own text. */
  var words = 0;
  document.querySelectorAll('.ssc-shell .ssa-prose').forEach(function (p) { words += txt(p).split(' ').length; });
  var minutes = head.querySelector('[data-ssc-minutes]');
  if (minutes && words > 200) minutes.textContent = Math.max(1, Math.round(words / 230)) + ' min read';

  /* 4. Current entry and progress. */
  var top = parseInt(getComputedStyle(head).getPropertyValue('--ssa-top'), 10) || 96;
  var buyZone = document.querySelector(head.getAttribute('data-ssc-buy') || '#ss-buy');
  var dock = document.querySelector('[data-ssc-dock]');
  var inView = false, shown = false;
  function update() {
    var y = window.scrollY, doc = document.documentElement;
    var pct = Math.max(0, Math.min(100, (y / Math.max(1, doc.scrollHeight - window.innerHeight)) * 100));
    document.documentElement.style.setProperty('--ssa-progress', pct.toFixed(1));
    var current = null;
    entries.forEach(function (e) { if (e.el.getBoundingClientRect().top - top - 24 <= 0) current = e; });
    lists.forEach(function (ol) {
      ol.querySelectorAll('a').forEach(function (a) {
        var on = current && a.getAttribute('href') === '#' + current.id;
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
    });
    if (dock) {
      var next = y > 480 && !inView && !sheetOpen;
      if (next !== shown) { shown = next; dock.classList.toggle('is-visible', shown); dock.setAttribute('aria-hidden', shown ? 'false' : 'true'); }
    }
  }
  var zone = buyZone || document.querySelector('[id$="__buy_product"]');
  if (zone && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      inView = es.some(function (e) { return e.isIntersecting; });
      document.body.classList.toggle('ssc-buy-in-view', inView);
      update();
    }, { rootMargin: '0px 0px -40px 0px' }).observe(zone.closest('.shopify-section') || zone);
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });

  /* 5. The sheet. */
  var sheet = document.querySelector('[data-ssc-sheet]'), sheetOpen = false;
  function setSheet(open) {
    if (!sheet) return;
    sheetOpen = open;
    sheet.classList.toggle('is-open', open);
    sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    update();
  }
  document.querySelectorAll('[data-ssc-sheet-open]').forEach(function (b) { b.addEventListener('click', function () { setSheet(true); }); });
  document.querySelectorAll('[data-ssc-sheet-close]').forEach(function (b) { b.addEventListener('click', function () { setSheet(false); }); });
  if (sheet) sheet.addEventListener('click', function (e) { if (e.target.closest('a')) setSheet(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheetOpen) setSheet(false); });

  /* 6. Smooth in-page moves that clear the floating header. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(history.state, '', a.getAttribute('href'));
  });

  /* 7. Page edges from the site header (logo left, last header button right), and the rail placed under
     whatever is pinned at the top (the deal bar always, the header while it is on screen). */
  var rail2 = head.querySelector('[data-ssc-rail]');
  var headerEl = document.querySelector('.shopify-section--header, [id$="__header"]');
  function edges() {
    var logo = document.querySelector('.header__logo');
    var items = headerEl ? [].slice.call(headerEl.querySelectorAll('a, button')) : [];
    var right = 0;
    items.forEach(function (el) { var b = el.getBoundingClientRect(); if (b.width && b.right > right) right = b.right; });
    if (logo) document.body.style.setProperty('--ssc-l', Math.round(logo.getBoundingClientRect().left) + 'px');
    if (right) document.body.style.setProperty('--ssc-r', Math.max(16, Math.round(document.documentElement.clientWidth - right)) + 'px');
  }
  function pinnedBottom() {
    var b = 0;
    [document.querySelector('.ss-dealbar'), headerEl].forEach(function (el) {
      if (!el) return;
      var r = el.getBoundingClientRect();
      if (r.bottom > b && r.top < 4 + b) b = r.bottom;
    });
    return b;
  }
  function placeRail() {
    if (!rail2) return;
    var top = Math.round(Math.max(pinnedBottom(), head.getBoundingClientRect().top, 0) + 28);
    rail2.style.top = top + 'px';
    rail2.style.maxHeight = (window.innerHeight - top - 24) + 'px';
    var foot = document.querySelector('.shopify-section--footer, footer');
    if (foot) rail2.classList.toggle('is-off', foot.getBoundingClientRect().top < rail2.getBoundingClientRect().bottom + 24);
  }
  edges();
  window.addEventListener('resize', edges, { passive: true });
  window.addEventListener('load', function () { edges(); placeRail(); });
  window.addEventListener('scroll', placeRail, { passive: true });
  window.addEventListener('resize', placeRail, { passive: true });
  placeRail();

  /* 8. What is pinned at the top, for the versus bar and anchor offsets (--ssc-pin). */
  function setPin() { document.body.style.setProperty('--ssc-pin', Math.round(pinnedBottom()) + 'px'); }
  window.addEventListener('scroll', setPin, { passive: true });
  window.addEventListener('resize', setPin, { passive: true });
  setPin();

  /* 9. Versus table. Phones (<700px): one rival at a time beside Second Shower, paged by the pinned pager
     (arrows at both ends, a tab per brand) or a sideways swipe. 700px+: every column is in the table,
     Second Shower and the row names stay pinned (CSS sticky) and the arrows above scroll the rest. */
  function centerTab(tab) {
    var row = tab && tab.parentNode;
    if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: tab.offsetLeft - (row.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth' });
  }
  document.querySelectorAll('[data-ssc-vs]').forEach(function (vs) {
    var count = parseInt(vs.getAttribute('data-count'), 10) || 0;
    if (count < 2) return;
    var pager = vs.querySelector('[data-ssc-vs-pager]'), scrollnav = vs.querySelector('[data-ssc-vs-scrollnav]');
    var tabs = [].slice.call(vs.querySelectorAll('[data-ssc-vs-pick]'));
    var prev = vs.querySelector('[data-ssc-vs-prev]'), next = vs.querySelector('[data-ssc-vs-next]');
    var left = vs.querySelector('[data-ssc-vs-left]'), right = vs.querySelector('[data-ssc-vs-right]');
    var frame = vs.querySelector('[data-ssc-vs-frame]');
    var current = 1, mode = '';
    function paged() {
      current = Math.max(1, Math.min(current, count));
      vs.querySelectorAll('[data-col]').forEach(function (cell) { cell.classList.toggle('is-off', parseInt(cell.getAttribute('data-col'), 10) !== current); });
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', parseInt(t.getAttribute('data-ssc-vs-pick'), 10) === current ? 'true' : 'false'); });
      if (prev) prev.disabled = current <= 1;
      if (next) next.disabled = current >= count;
      centerTab(vs.querySelector('[data-ssc-vs-pick="' + current + '"]'));
    }
    function scrollState() {
      if (!frame) return;
      var max = frame.scrollWidth - frame.clientWidth;
      vs.classList.toggle('has-more', frame.scrollLeft < max - 4);
      vs.classList.toggle('is-scrolled', frame.scrollLeft > 4);
      if (left) left.disabled = frame.scrollLeft <= 4;
      if (right) right.disabled = frame.scrollLeft >= max - 4;
      if (scrollnav) scrollnav.hidden = max <= 4;
    }
    function setMode() {
      var m = window.innerWidth < 700 ? 'paged' : 'scroll';
      if (m === mode) { if (m === 'paged') paged(); else scrollState(); return; }
      mode = m;
      vs.classList.toggle('is-paged', m === 'paged');
      vs.classList.toggle('is-scroll', m === 'scroll');
      if (pager) pager.hidden = m !== 'paged';
      if (m === 'paged') { if (scrollnav) scrollnav.hidden = true; paged(); }
      else { vs.querySelectorAll('[data-col].is-off').forEach(function (c) { c.classList.remove('is-off'); }); scrollState(); }
    }
    function stepCol(d) {
      var col = vs.querySelector('thead th[data-col]');
      if (frame && col) frame.scrollBy({ left: d * col.getBoundingClientRect().width, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { current--; paged(); });
    if (next) next.addEventListener('click', function () { current++; paged(); });
    tabs.forEach(function (t) { t.addEventListener('click', function () { current = parseInt(t.getAttribute('data-ssc-vs-pick'), 10); paged(); }); });
    if (left) left.addEventListener('click', function () { stepCol(-1); });
    if (right) right.addEventListener('click', function () { stepCol(1); });
    if (frame) {
      frame.addEventListener('scroll', scrollState, { passive: true });
      var sx = 0, sy = 0;
      frame.addEventListener('touchstart', function (ev) { sx = ev.touches[0].clientX; sy = ev.touches[0].clientY; }, { passive: true });
      frame.addEventListener('touchend', function (ev) {
        if (mode !== 'paged') return;
        var dx = ev.changedTouches[0].clientX - sx, dy = ev.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) { current += dx < 0 ? 1 : -1; paged(); }
      }, { passive: true });
    }
    window.addEventListener('resize', setMode, { passive: true });
    setMode();
  });

  /* 9b. Tabs (the chloramine chapter's city lists). */
  document.querySelectorAll('[data-ssc-tabs]').forEach(function (box) {
    var list = box.querySelector('[role="tablist"]');
    var tabs = [].slice.call(box.querySelectorAll('[role="tab"]'));
    if (!list || tabs.length < 2) return;
    function pick(i) {
      tabs.forEach(function (t, k) {
        var on = k === i, panel = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panel) panel.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(i); });
      t.addEventListener('keydown', function (ev) {
        if (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft') return;
        var k = (i + (ev.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
        pick(k); tabs[k].focus(); ev.preventDefault();
      });
    });
    list.hidden = false;
    box.classList.add('is-on');
    pick(0);
  });

  /* 10. Brand deck: one card in focus; arrows, chips and the count follow the track's scroll. */
  document.querySelectorAll('[data-ssc-deck]').forEach(function (deck) {
    var track = deck.querySelector('[data-ssc-deck-track]');
    var cards = [].slice.call(deck.querySelectorAll('[data-ssc-deck-card]'));
    if (!track || cards.length < 2) return;
    var bar = deck.querySelector('[data-ssc-deck-bar]');
    var chips = [].slice.call(deck.querySelectorAll('[data-ssc-deck-pick]'));
    var prev = deck.querySelector('[data-ssc-deck-prev]'), next = deck.querySelector('[data-ssc-deck-next]');
    var countEl = deck.querySelector('[data-ssc-deck-count]');
    var current = 0;
    function go(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      track.scrollTo({ left: cards[i].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
    }
    function sync() {
      var x = track.scrollLeft, best = 0, d = Infinity;
      cards.forEach(function (c, i) { var dd = Math.abs(c.offsetLeft - cards[0].offsetLeft - x); if (dd < d) { d = dd; best = i; } });
      current = best;
      chips.forEach(function (ch, i) { ch.setAttribute('aria-pressed', i === current ? 'true' : 'false'); });
      cards.forEach(function (c, i) { c.setAttribute('aria-hidden', i === current ? 'false' : 'true'); });
      if (countEl) countEl.textContent = (current + 1) + ' of ' + cards.length;
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === cards.length - 1;
      centerTab(chips[current]);
    }
    if (bar) bar.hidden = false;
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    chips.forEach(function (ch, i) { ch.addEventListener('click', function () { go(i); }); });
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  });

  setTimeout(update, 0);
})();
